import { useState } from 'react'

interface ICarrierObject {
  id: number | string
  name: string | undefined
}

interface IUseCarrierProps {
  carrierId?: number
  carrierName?: string
  carriers?: ICarrierObject[] | undefined
}

// This hook is used to set carrier in AddLaneAlertModal Component
const useCarrier = ({ carrierId, carrierName, carriers }: IUseCarrierProps) => {
  const [carrier, setCarrier] = useState<ICarrierObject>(() => {
    let returnCarrier
    if (carrierId) {
      returnCarrier = {
        id: carrierId?.toString() || '',
        name: carrierName,
      }
    } else if (carriers && carriers?.length > 0) {
      returnCarrier = {
        id: carriers[0].id.toString(),
        name: carriers[0].name || '',
      }
    } else {
      returnCarrier = {
        id: '',
        name: '',
      }
    }

    return returnCarrier
  })
  return { carrier, setCarrier }
}

export default useCarrier
